module.exports = __webpack_public_path__ + "static/media/3-hybrid.339bf70d.png";